import { render, staticRenderFns } from "./ContactItem.vue?vue&type=template&id=6431d976&scoped=true&"
import script from "./ContactItem.vue?vue&type=script&lang=ts&"
export * from "./ContactItem.vue?vue&type=script&lang=ts&"
import style0 from "./ContactItem.vue?vue&type=style&index=0&id=6431d976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6431d976",
  null
  
)

export default component.exports